import React from 'react';
import type { DocumentStats, DocumentSourceType } from '../../types/aggregated-documents';
import { aggregatedDocumentsService } from '../../services/aggregated-documents-service';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface DocumentStatsProps {
  stats: DocumentStats;
}

export const DocumentStatsComponent: React.FC<DocumentStatsProps> = ({ stats }) => {
  const formatBytes = aggregatedDocumentsService.formatFileSize;
  const getSourceIcon = aggregatedDocumentsService.getSourceTypeIcon;
  const getSourceLabel = aggregatedDocumentsService.getSourceTypeLabel;

  const kpis: [string, React.ReactNode][] = [
    ['Total de Documentos', stats.total],
    ['Tamanho Total', formatBytes(stats.totalSize)],
    ['Confidenciais', stats.confidentialCount],
    ['Recentes (30 dias)', stats.recentCount]
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle><h3>Estatísticas de Documentos</h3></CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {kpis.map(([label, value]) => (
            <div key={label} className="min-w-0 rounded-lg border bg-muted/40 p-3">
              <div className="mb-1 truncate text-xs text-muted-foreground">{label}</div>
              <div className="text-xl font-semibold tabular-nums">{value}</div>
            </div>
          ))}
        </div>

        <div className="border-t pt-4">
          <h4 className="mb-3 text-sm font-semibold">Por Origem</h4>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
            {Object.entries(stats.totalBySource).map(([source, count]) => (
              <div key={source} className="flex min-w-0 items-center gap-2">
                <span className="text-2xl" aria-hidden="true">{getSourceIcon(source as DocumentSourceType)}</span>
                <div className="min-w-0">
                  <div className="truncate text-xs text-muted-foreground">
                    {getSourceLabel(source as DocumentSourceType)}
                  </div>
                  <div className="text-sm font-semibold tabular-nums">{count}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
